<template lang="pug">
  v-container.mb-3
    v-row(justify="center")
      v-col(cols="4")
        v-card.mb-5(v-if="urlCardImage")
          v-card-text.py-0
            v-row(justify="end")
              v-col.py-0(cols="1")
                v-btn(icon style="z-index: 1")
                  v-icon(color="orange" @click="removeCardImage") mdi-close-box-outline
          v-img(:src="urlCardImage")
        span.file-wrapper
          input(type="file" ref="cardImage" @change="cardImageFileURL" accept="image/*")
          span.button.text-center {{ urlCardImage ? 'Change Card Image' : 'Add Card Image'}}
        //- v-file-input(v-model="cardImage" prepend-icon="mdi-camera" label="Add Card Image" @change="cardImageFileURL" single-line full-width hide-details chips)
      v-col.py-0(cols="8")
        template(v-if="urlMedia.length > 0")
          v-row(v-for="(url, index) in urlMedia")
            v-col(cols="12")
              v-card
                v-row(align="center")
                  v-col.ml-3(cols="1")
                    v-btn(icon :disabled="urlMedia.length <= 1 || index === 0")
                      v-icon(large @click="changeOrderUp(index)") mdi-menu-up
                    v-btn(icon :disabled="urlMedia.length <= 1 || index === urlMedia.length - 1")
                      v-icon(large @click="changeOrderDown(index)") mdi-menu-down
                  v-col(cols="3")
                    v-img(v-if="url.type === 'image'" :src="url.url" aspect-ratio="1.5" )
                    div.text-center(v-else)
                      v-btn(icon :href="url.url" target="_blank" :disabled="url.url.substr(0, 4) !== 'http'")
                        v-icon(x-large) mdi-video
                  v-col(cols="6")
                    template(v-if="url.id || url.progress === 100")
                      h4.text-center Uploaded
                        v-icon mdi-tick
                    v-progress-Linear(v-else v-model="url.progress" color="orange" height="7")
                  v-col(cols="1")
                    v-card-text.py-0
                      v-row(justify="end")
                        v-col.py-0(cols="1")
                          v-btn(icon style="z-index: 1")
                            v-icon(color="orange" @click="removeMedia(index)") mdi-close-box-outline
        v-row(justify="center")
          v-col(cols="6")
            //- v-file-input(v-model="mediaFile" prepend-icon="mdi-folder-multiple-image" label="Media" multiple @change="mediaFileURL" single-line full-width hide-details chips)
            span.file-wrapper
              input(type="file" ref="mediaFile" @change="mediaFileURL" accept="video/*,image/*")
              span.button.text-center Add Media
    v-footer(app inset padless color="transparent")
      v-row(justify="center")
        v-col(cols="8" style="background-color: #424242")
          v-row(justify="center")
            v-col.py-0(cols="8")
              v-btn(block color="success" @click="saveMedias" :disabled="!$store.state.groups.includes('Marketing')") Save
              span.caption.warning--text(v-if="!saveEnabled") Warning: Currently being edited by other user
</template>

<script>
export default {
  name: 'MediaTab',
  props: ['card', 'saveEnabled'],
  data: () => ({
    cardImage: null,
    mediaFile: null,
    // mediaFiles: [],
    urlCardImage: '',
    urlMedia: [],
    progress: 0
  }),
  watch: {
    progress(val) {
      if (val === this.urlMedia.length) {
        this.$alert.success('Upload Media Successful!')
        this.urlCardImage = this.card
        this.fetchMedias()
        this.progress = 0
      }
    }
  },
  mounted () {
    this.urlCardImage = this.card
    this.fetchMedias()
  },
  methods: {
    fetchMedias () {
      let id = this.$route.params.productID
      this.$axios.get(`/medias/?category=header&ordering=order&product=${id}`)
        .then(resp => {
          this.urlMedia = [...resp.data.results]
        })
    },
    cardImageFileURL () {
      // console.log(this.$refs.cardImage.files[0])
      this.cardImage = this.$refs.cardImage.files[0]
      let file = this.cardImage
      let reader = new FileReader()
      reader.onload = e => {
        this.urlCardImage = e.target.result
      }
      reader.readAsDataURL(file)
    },
    mediaFileURL () {
      // console.log(this.$refs.mediaFile.files)
      if(this.$refs.mediaFile.files[0].type.substr(0, 5) === "image") {
        this.mediaFile = this.$refs.mediaFile.files[0]
        let file = this.mediaFile
        let reader = new FileReader()
        reader.onload = e => {
          this.urlMedia.push({type: 'image', url: e.target.result, file: this.$refs.mediaFile.files[0], progress: 0})
        }
        reader.readAsDataURL(file)
      } else {
        this.urlMedia.push({type: 'video', url: this.$refs.mediaFile.files[0].name, file: this.$refs.mediaFile.files[0], progress: 0})
      }
      // this.mediaFiles.push(this.$refs.mediaFile.files[0])
    },
    saveMedias () {
      let id = this.$route.params.productID
      if (this.cardImage) {
        let formData = new FormData()
        formData.append('card_image', this.cardImage)
        this.$axios.patch(`/products/${id}/`, formData, { headers: { 'Content-Type': 'multipart/form-data' }}).then(resp => {
        }).catch(e => {
          console.log(e)
        })
      }
      if (this.urlMedia.length > 0) {
        this.urlMedia.forEach((m, index) => {
          if (!m.id) {
            let formData = new FormData()
            formData.append('type', m.type)
            formData.append('category', 'header')
            formData.append('url', m.file)
            formData.append('order', index + 1)
            formData.append('product', id)
            this.$axios.post(`/medias/`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: progressEvent => m.progress = Math.round( (progressEvent.loaded * 100) / progressEvent.total ) }).then(resp => {
              this.progress++
              // alert('upload success')
            }).catch(e => {
              // alert('upload fail')
            })
          } else {
            this.$axios.patch(`/medias/${m.id}/`, { order: index + 1 }).then(resp => {
              this.progress++
              // alert('upload success')
            }).catch(e => {
              // alert('upload fail')
            })
          }
        })
      }
      // return console.log(check)
      // if (check > 0) {
      //   this.$alert.failed('Error Upload Media!')
      // } else {
      //   this.$alert.success('Save Media Successful!')
      // }
    },
    removeCardImage () {
      if(this.card) {
        let id = this.$route.params.productID
        this.$axios.patch(`/products/${id}/`, {card_image: null})
          .then(resp => {
            this.cardImage = null
          this.urlCardImage = null
            this.$showAlert('grey darken-2','Remove Image Successful')
          })
      } else {
        this.cardImage = null
        this.urlCardImage = null
      }
    },
    removeMedia (i) {
      if(this.urlMedia[i].id) {
        let id = this.urlMedia[i].id
        this.$axios.delete(`/medias/${id}/`)
          .then(resp => {
            this.$showAlert('grey darken-2','Remove Image Successful')
            // this.fetchMedia()
            this.urlMedia.splice(i, 1)
          })
      } else {
        this.urlMedia.splice(i, 1)
      }
    },
    changeOrderUp (index) {
      let item = this.urlMedia.slice(index, index + 1)
      this.urlMedia.splice(index, 1)
      this.urlMedia.splice(index - 1, 0, item[0])
    },
    changeOrderDown (index) {
      let item = this.urlMedia.slice(index, index + 1)
      this.urlMedia.splice(index, 1)
      this.urlMedia.splice(index + 1, 0, item[0])
    }
  }
}
</script>

<style lang="scss" scoped>
.file-wrapper {
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.file-wrapper input {
  cursor: pointer;
  font-size: 100px;
  filter: alpha(opacity=1);
  -moz-opacity: 0.01;
  opacity: 0.01;
  position: absolute;
  right: 0;
  top: 0;
}
.file-wrapper .button {
  background: orange;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 11px;
  font-weight: bold;
  padding: 6px 18px;
  text-transform: uppercase;
  width: 100%
}

</style>